export function produceSecureUrl(input) {
    var baseUrl = input.baseUrl, policy = input.policy;
    var hasUrlParams = baseUrl.indexOf("?") > -1;
    var cleanPolicy = policy.startsWith("?") ? policy.substring(1) : policy;
    return baseUrl + (hasUrlParams ? "&" : "?") + cleanPolicy;
}
